import { render, staticRenderFns } from "./UploadAudio.vue?vue&type=template&id=53b8aee5"
import script from "./UploadAudio.vue?vue&type=script&lang=ts"
export * from "./UploadAudio.vue?vue&type=script&lang=ts"
import style0 from "./UploadAudio.vue?vue&type=style&index=0&id=53b8aee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports